import React, { useState } from 'react';
import LoginForm from '../../../components/ui/forms/login';
import { login, authenticate } from '../../../services/auth';
import { message } from 'antd';
import { useDispatch } from 'react-redux';
import './Login.css';

const Login = ({ history }) => {
  const [values, setValues] = useState({
    email: '',
    password: '',
  });
  const [loading, setLoading] = useState(false);

  const { email, password } = values;

  const dispatch = useDispatch();

  const handleChange = (name) => (event) => {
    setValues({ ...values, [name]: event.target.value });
  };

  const translateErrorMessage = (message) => {
    if (message === 'User with that email does not exist' || message === 'Password is incorrect') {
      return 'Credenciais incorretas.';
    }
    return message;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await login({
        email: email,
        password: password,
      });
      if (data) {
        //Save user and token to LocalSTorage
        authenticate(data);
        //Save user and token to redux
        dispatch({
          type: 'LOGGED_IN_USER',
          payload: data.token,
        });
        history.push('user/dashboard');
        window.location.reload();
      }
    } catch (err) {
      console.log(err);
      if (err.response && err.response.status === 400) {
        const errorMessage = err.response.data.message || 'Credenciais incorretas';
        message.error(errorMessage, 4);
      } else {
        message.error('Erro inesperado ao fazer login.', 4);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='login-page'>
      <div className='login-container'>
        <div className='login-wrapper'>
          <div className='login-form-wrapper'>
            <LoginForm
              email={email}
              password={password}
              handleChange={handleChange}
              handleSubmit={handleSubmit}
              loading={loading}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
